export const AllQuantifyRoutes = {
  index: "/quantify",
};
